@if (column.type === ColumnType.DATE_TIME) {
  <td>
    <input type='datetime-local' pInputText [required]='required' [disabled]='readonly' [style]="{'width':'100%'}"
           (keydown.space)='$event.stopPropagation();' [(ngModel)]='data[column.field]'>
  </td>
} @else if (column.type === ColumnType.DATE) {
  <td>
    <input type='date' pInputText [required]='required' [disabled]='readonly' [style]="{'width':'100%'}"
           (keydown.space)='$event.stopPropagation();' [(ngModel)]='data[column.field]'>
  </td>
} @else if (column.type === ColumnType.BOOLEAN) {
  <td>
    <p-checkbox pRipple [binary]='true' [disabled]='readonly' [(ngModel)]='data[column.field]'></p-checkbox>
  </td>
} @else if (column.type === ColumnType.ACTIONS) {
  <td>
    <ng-content></ng-content>
  </td>
} @else {
  <td>
    <input pInputText [required]='required' [disabled]='readonly' [style]="{'width':'100%'}"
           (keydown.space)='$event.stopPropagation();' [(ngModel)]='data[column.field]'>
  </td>
}
